<template>
    <div class="public-content">
        <div class="public">
            <sidebar1></sidebar1>
            <div class="public-right">
                <TopBar></TopBar>
            </div>
        </div>
    </div>
</template>

<script>
    import sidebar1 from '@/components/sidebar1.vue'
    import TopBar from '@/components/TopBar.vue'

    export default {
        name: "public1",
        data() {
            return {
                userid: window.localStorage.userid,
                isChild: window.localStorage.isChild,
            }
        },
        components: {
            sidebar1,
            TopBar,
        },
    }
</script>

<style scoped>
    .public-content {
        height: 100%;
    }
    .public-right{
    }
</style>